import draw from './draw';

export default (mouseEvents, wgDimension) => (selection) => {
  selection.selectAll('svg').remove();

  const root = selection.selectAll('svg').data(selection.data());
  root.exit().remove();

  const spaceScrollY = 8;
  const containerPadding = 20;
  const containerWidth = wgDimension.width - containerPadding - spaceScrollY;

  const svg = root
    .enter()
    .append('svg')
    .attr('width', containerWidth)
    .attr('height', 82);

  svg
    .append('g')
    .classed('viewport', true)
    .style('transform', 'translate(0, 0)')
    .call(draw(mouseEvents, containerWidth));
};



// WEBPACK FOOTER //
// ./src/components/dashboard_widgets/shipment_completion/index.js